import { Eye, EyeOff } from "lucide-react";
import { useState } from "react";
import { useMediaQuery } from "../../hooks/useMediaQuery";
import { useTranslations } from "../../i18n";
import { textFieldButtonSize } from "../../utils";
import { IconButton } from "../Button/IconButton";
import { Input } from "./Input";
import type { IInputPasswordProps, IInputSize } from "./types";

export const InputPassword = (props: IInputPasswordProps) => {
  const { t } = useTranslations();
  const isMobile = useMediaQuery("(max-width: 639px)");
  const size: IInputSize = props.size || (isMobile ? "lg" : "md");
  const [visible, setVisible] = useState<boolean>(false);

  const onChangeType = () => {
    setVisible((visible: boolean) => !visible);
  };

  return (
    <Input
      {...props}
      autoComplete={props.autoComplete || "off"}
      placeholder={props.placeholder || t("ui.input.password")}
      type={visible ? "text" : "password"}
      endAccessory={
        // A toggle: the name stays "Show password", the pressed state says whether it is shown.
        <IconButton
          size={textFieldButtonSize[size]}
          variant="ghost"
          color="neutral"
          disabled={props.disabled}
          onClick={onChangeType}
          content={visible ? <EyeOff /> : <Eye />}
          aria-label={t("ui.input.showPassword")}
          aria-pressed={visible}
        />
      }
    />
  );
};
